import { FC } from 'react'

import { InternalTransferList } from 'commons/types/DTO/bank'
import { TableDataQa } from 'commons/types/enums'
import { Table } from 'ui/components/Table'

import { InternalTransferTableProps } from './InternalTransferTableProps'
import { columns } from './columns'
import { Filter } from './components/Filter'
import { useInternalTransferTable } from './hooks'

export const InternalTransferTable: FC<InternalTransferTableProps> = ({
  items,
  tableState,
  filterForm,
  setLoading,
  loading,
  totalCount,
  statuses
}) => {
  const { expanded, onFilterToggle, page, size, onPageChange } = tableState
  const { mappedInternalTransfers, CancelConfirmation, startCancel } = useInternalTransferTable(
    tableState,
    filterForm,
    items,
    setLoading
  )

  return (
    <>
      <CancelConfirmation />
      <Filter form={filterForm} expanded={expanded} onToggle={onFilterToggle} statuses={statuses} />
      <Table<InternalTransferList>
        dataQa={TableDataQa.BP_INTERNAL_TRANSFERS_LIST}
        columns={columns({ onCancel: startCancel })}
        dataSource={mappedInternalTransfers}
        loading={loading}
        pagination={{
          page,
          size,
          onChange: (page: number, size: number) => {
            onPageChange(page, size)
          },
          total: totalCount
        }}
      />
    </>
  )
}
